import type { UsagePlanId } from "./types";

export const defaultTemplateValues = {
  greeting: "Thank you for visiting",
  satisfactionQuestion: "Were you satisfied with your visit today?",
  unhappyMessage: "We are sorry to hear that.",
  finalThanks: "Thank you for taking a moment to rate your visit.",
};

export const usagePlans: Array<{
  id: UsagePlanId;
  label: string;
  monthlyPrice: number;
  includedMessages: number;
}> = [
  {
    id: "starter_250",
    label: "Starter",
    monthlyPrice: 50,
    includedMessages: 250,
  },
  {
    id: "growth_1000",
    label: "Growth",
    monthlyPrice: 100,
    includedMessages: 1000,
  },
  {
    id: "scale_5000",
    label: "Scale",
    monthlyPrice: 200,
    includedMessages: 5000,
  },
];

export const defaultUsagePlanId: UsagePlanId = "starter_250";

export const csvHeaders = [
  "phone_number",
  "consent_attested_by",
] as const;

export const assumedConsentMethod = "other";

export const consentMethods = [
  "web_form",
  "paper_form",
  "checkbox",
  "sms_opt_in",
  "other",
] as const;
